/**
 * Item of a shaker control sequence
 */
export type ShakerControlSequenceItem = {
  type: string;
  value: any;
};

/**
 * A sequence of items to control a shaker
 */
export type ShakerControlSequence = ShakerControlSequenceItem[];


/**
 * Check if an object is a {@link ShakerControlSequenceItem}
 *
 * @param obj Object to check
 * @returns True if the object is a {@link ShakerControlSequenceItem}, false otherwise
 */
export function isShakerControlSequenceItem(obj: any): obj is ShakerControlSequenceItem {
  return obj && typeof obj.type === 'string' && obj.value !== undefined;
}


/**
 * Check if an object is a {@link ShakerControlSequence}
 *
 * @param obj Object to check
 * @returns True if the object is a {@link ShakerControlSequence}, false otherwise
 */
export function isShakerControlSequence(obj: any): obj is ShakerControlSequence {
  return Array.isArray(obj) && obj.every(isShakerControlSequenceItem);
}
